<div class="body-text-two blue-highlight">Query Type:</div>
<mat-radio-group
  [ngModelOptions]="{ standalone: true }"
  color="primary"
  [(ngModel)]="radioSelected"
  (change)="onRadioChange($event)"
  >
  @for (obj of queryTypeChoices; track obj) {
    <mat-radio-button
      class="h-[24px]"
      style="display: block"
      [value]="obj.value"
      >
      {{ obj.key }}
    </mat-radio-button>
  }
</mat-radio-group>

@if (radioSelected === 'singleDate') {
  <div>
    <div class="grid grid-cols-2">
      <app-single-date
        [childField]="'singleDate'"
        (messageToParent)="parentFunction($event)"
      ></app-single-date>
    </div>
  </div>
}

@if (radioSelected === 'dateRange') {
  <div>
    <app-date-range
      [childField]="'dateRange'"
      (messageToParent)="parentFunction($event)"
    ></app-date-range>
  </div>
}

<div>
  @if (radioSelected === 'corporateDividends') {
    <div>
      @if (receivedFullUniverseState) {
        <div>
          <app-date-range [availableDays]="'week'"
            [childField]="'dateRange'"
            (messageToParent)="parentFunction($event)"
          ></app-date-range>
        </div>
      } @else {
        <app-date-range
          [setMax]="true"
          [childField]="'corporateDividends'"
          (messageToParent)="parentFunction($event)"
        ></app-date-range>
      }
      <app-corporate-actions-dividends></app-corporate-actions-dividends>
    </div>
  }
</div>

